import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import './styles.scss';

export const changeSelectValue = (selectRef, value) => {
  if (selectRef.current) { selectRef.current.setValue(value || ''); }
};

export const cancelSelectValue = (selectRef, value) => {
  if (selectRef.current) { selectRef.current.select.setValue(value || ''); }
};

export const clearSelectValue = (selectRef) => {
  if (selectRef.current) { selectRef.current.select.setValue(''); }
};

const EpFormSelect = forwardRef(({
  labelText, selectOptions, inputId, isSearchable,
  placeholderText, classError, inputName, selectDefaultValue,
  selectClassNamePrefix, onBlurFunc, onChangeFunc,
  customRef, minPortalWidth, customClass,
}) => {
  const customStyles = {
    menuPortal: provided => ({
      ...provided, zIndex: 9999, minWidth: minPortalWidth,
    }),
    menu: provided => ({ ...provided, zIndex: 9999 }),
  };

  return (
    <div className="select__container">
      {labelText && <label htmlFor={inputId} className="select__label">{labelText}</label>}
      <Select
        ref={customRef}
        id={inputId}
        name={inputName}
        classNamePrefix={selectClassNamePrefix}
        menuPortalTarget={document.body}
        menuPosition="fixed"
        styles={customStyles}
        className={` ${classError || customClass}`}
        placeholder={placeholderText}
        isSearchable={isSearchable}
        defaultValue={selectDefaultValue}
        menuPlacement="auto"
        onBlur={onBlurFunc}
        onChange={onChangeFunc}
        options={selectOptions}
        maxMenuHeight={180}
        menuShouldBlockScroll
      />
    </div>
  );
});

export default EpFormSelect;

EpFormSelect.defaultProps = {
  placeholderText: '',
  selectOptions: [],
  labelText: '',
  classError: '',
  isSearchable: true,
  selectDefaultValue: null,
  selectClassNamePrefix: 'select',
  customRef: null,
  onBlurFunc: null,
  minPortalWidth: null,
  customClass: '',
};

EpFormSelect.propTypes = {
  minPortalWidth: PropTypes.number,
  placeholderText: PropTypes.string,
  selectOptions: PropTypes.arrayOf(PropTypes.object),
  labelText: PropTypes.string,
  inputName: PropTypes.string.isRequired,
  inputId: PropTypes.string.isRequired,
  isSearchable: PropTypes.bool,
  classError: PropTypes.string,
  selectDefaultValue: PropTypes.objectOf(PropTypes.any),
  selectClassNamePrefix: PropTypes.string,
  onBlurFunc: PropTypes.func,
  onChangeFunc: PropTypes.func.isRequired,
  customRef: PropTypes.objectOf(PropTypes.any),
  customClass: PropTypes.string,
};
